 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		60: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		60: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "j/" + ({"0":"lib-components-flexonry~lib-tools-responsive~lib-tools-transitions~lib-utilities-anchors~src-compone~fccfb755","1":"vendors~lib-components-carousel~src-components-about-about~src-components-books-creation~src-compone~8d868b4e","2":"lib-components-forms","3":"lib-components-richtext","4":"lib-utilities-typography","5":"src-components-books-creation~src-components-books-purchase","6":"src-components-carousel","7":"src-components-products","8":"vendors~lib-components-richtext~src-components-richtext","9":"lib-components-carousel","10":"lib-components-dynamic_fields","11":"lib-components-flexonry","12":"lib-components-instafeed","13":"lib-tools-dom","14":"lib-tools-events","15":"lib-tools-fetch","16":"lib-tools-images","17":"lib-tools-responsive","18":"lib-tools-scrolling","19":"lib-tools-transitions","20":"lib-tools-urls","21":"lib-utilities-anchors","22":"lib-utilities-scroll_preventer","23":"src-components-404","24":"src-components-about-about","25":"src-components-about-books","26":"src-components-background","27":"src-components-books-admin","28":"src-components-books-creation","29":"src-components-books-detail","30":"src-components-books-purchase","31":"src-components-books-web","32":"src-components-cart","33":"src-components-colourful_carousel","34":"src-components-common","35":"src-components-footer","36":"src-components-forms","37":"src-components-header","38":"src-components-holding","39":"src-components-homepage","40":"src-components-instafeed","41":"src-components-journal","42":"src-components-menu","43":"src-components-orders","44":"src-components-pages","45":"src-components-reviews","46":"src-components-richtext","47":"src-components-staticpage","48":"src-utilities-cart","49":"src-utilities-currency","50":"src-utilities-typography","51":"src-utilities-videoplayer","52":"vendors~src-components-books-admin","53":"vendors~src-components-common","54":"[request]"}[chunkId]||chunkId) + "." + {"0":"545181e81c8d93ce73f1","1":"c9dde4da0e45373a1839","2":"d27fd2bb4554ca8222fd","3":"8e18cdb97ff3d668cc4b","4":"e807c358cf43ab850ada","5":"d117f942e256dbef4cfc","6":"45f0779ac34b775f6655","7":"c06101e4dab0733c55d7","8":"44c35d97d7afacf87773","9":"4c98513e4d82ddb5cb08","10":"8e9e783747205a6370d2","11":"b850140055a14c43c7d0","12":"c211f5a20ed2ee2473d4","13":"23c72c5be31f039767ac","14":"4ea43b70cc222d5359f9","15":"02417b6db50bac61153c","16":"151f8ee139c05da510ba","17":"8a4a6bac5ba35e0a2ed3","18":"f6691fa58a364bb9ae7f","19":"40e5cebae99170eea39f","20":"cd19222dda9fb9f064f1","21":"720ed4733767bcc659c3","22":"ff621677da28925c757b","23":"26091f034121f5518c70","24":"6e7139bc18362aef1ff2","25":"dc496cc8dc418163cf55","26":"e3e95b5d42ebb70eca8a","27":"0e3f342093b168204ff7","28":"4da4a68fb586112707a4","29":"ad50448ec2b165138bb1","30":"49ca14485ad631575749","31":"a93371132b515e8b072a","32":"4a362fb4b48e5e821f42","33":"193fcb94e77219e1e941","34":"0b130b805d9ba414a874","35":"db42bc02cc717ac58063","36":"3468fc274382c360e18b","37":"e21386c68feffeffecc7","38":"f01aaa2b11ff0b472b4b","39":"6e4d91df501bc9709e05","40":"c196bd8b60970464abb3","41":"59fad84d88e42c23586d","42":"d1ebf701c814bbffcee1","43":"b1bd2cef9ab6cffd3036","44":"5eedf6cbc10281a74eb7","45":"25ac943fd0d30838c75f","46":"6057d04e73f090cd55df","47":"2fb40cf9fe7ce697b95f","48":"beed6a6cc404afeec512","49":"d9e494ce3e0cf2f3b3eb","50":"b885de6666eb57033bd8","51":"6d2a21b0cb2824cff203","52":"7d0ac63ebb6fb32b998b","53":"05afa06a0dfac64b7b56","54":"3d13325bb93461942971"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"11":1,"12":1,"21":1,"22":1,"23":1,"24":1,"25":1,"27":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"51":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "c/" + ({"0":"lib-components-flexonry~lib-tools-responsive~lib-tools-transitions~lib-utilities-anchors~src-compone~fccfb755","1":"vendors~lib-components-carousel~src-components-about-about~src-components-books-creation~src-compone~8d868b4e","2":"lib-components-forms","3":"lib-components-richtext","4":"lib-utilities-typography","5":"src-components-books-creation~src-components-books-purchase","6":"src-components-carousel","7":"src-components-products","8":"vendors~lib-components-richtext~src-components-richtext","9":"lib-components-carousel","10":"lib-components-dynamic_fields","11":"lib-components-flexonry","12":"lib-components-instafeed","13":"lib-tools-dom","14":"lib-tools-events","15":"lib-tools-fetch","16":"lib-tools-images","17":"lib-tools-responsive","18":"lib-tools-scrolling","19":"lib-tools-transitions","20":"lib-tools-urls","21":"lib-utilities-anchors","22":"lib-utilities-scroll_preventer","23":"src-components-404","24":"src-components-about-about","25":"src-components-about-books","26":"src-components-background","27":"src-components-books-admin","28":"src-components-books-creation","29":"src-components-books-detail","30":"src-components-books-purchase","31":"src-components-books-web","32":"src-components-cart","33":"src-components-colourful_carousel","34":"src-components-common","35":"src-components-footer","36":"src-components-forms","37":"src-components-header","38":"src-components-holding","39":"src-components-homepage","40":"src-components-instafeed","41":"src-components-journal","42":"src-components-menu","43":"src-components-orders","44":"src-components-pages","45":"src-components-reviews","46":"src-components-richtext","47":"src-components-staticpage","48":"src-utilities-cart","49":"src-utilities-currency","50":"src-utilities-typography","51":"src-utilities-videoplayer","52":"vendors~src-components-books-admin","53":"vendors~src-components-common","54":"[request]"}[chunkId]||chunkId) + "." + {"0":"545181e81c8d93ce73f1","1":"c9dde4da0e45373a1839","2":"d27fd2bb4554ca8222fd","3":"8e18cdb97ff3d668cc4b","4":"e807c358cf43ab850ada","5":"d117f942e256dbef4cfc","6":"45f0779ac34b775f6655","7":"c06101e4dab0733c55d7","8":"44c35d97d7afacf87773","9":"4c98513e4d82ddb5cb08","10":"8e9e783747205a6370d2","11":"b850140055a14c43c7d0","12":"c211f5a20ed2ee2473d4","13":"23c72c5be31f039767ac","14":"4ea43b70cc222d5359f9","15":"02417b6db50bac61153c","16":"151f8ee139c05da510ba","17":"8a4a6bac5ba35e0a2ed3","18":"f6691fa58a364bb9ae7f","19":"40e5cebae99170eea39f","20":"cd19222dda9fb9f064f1","21":"720ed4733767bcc659c3","22":"ff621677da28925c757b","23":"26091f034121f5518c70","24":"6e7139bc18362aef1ff2","25":"dc496cc8dc418163cf55","26":"e3e95b5d42ebb70eca8a","27":"0e3f342093b168204ff7","28":"4da4a68fb586112707a4","29":"ad50448ec2b165138bb1","30":"49ca14485ad631575749","31":"a93371132b515e8b072a","32":"4a362fb4b48e5e821f42","33":"193fcb94e77219e1e941","34":"0b130b805d9ba414a874","35":"db42bc02cc717ac58063","36":"3468fc274382c360e18b","37":"e21386c68feffeffecc7","38":"f01aaa2b11ff0b472b4b","39":"6e4d91df501bc9709e05","40":"c196bd8b60970464abb3","41":"59fad84d88e42c23586d","42":"d1ebf701c814bbffcee1","43":"b1bd2cef9ab6cffd3036","44":"5eedf6cbc10281a74eb7","45":"25ac943fd0d30838c75f","46":"6057d04e73f090cd55df","47":"2fb40cf9fe7ce697b95f","48":"beed6a6cc404afeec512","49":"d9e494ce3e0cf2f3b3eb","50":"b885de6666eb57033bd8","51":"6d2a21b0cb2824cff203","52":"7d0ac63ebb6fb32b998b","53":"05afa06a0dfac64b7b56","54":"3d13325bb93461942971"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"3": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"6": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"7": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"9": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"11": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"12": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"13": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"23": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"24": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"25": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"26": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"28": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"29": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"30": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"31": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"34": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"37": [
 				0,
 				21,
 				4,
 				50,
 				48,
 				49
 			],
 			"39": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"40": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"41": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"42": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"43": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"44": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"46": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"47": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"51": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			],
 			"54": [
 				0,
 				21,
 				4,
 				50,
 				37,
 				48,
 				49
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "8D23");
